import Vue from 'vue';
import Router from 'vue-router';

import Intro from '@/pages/Intro';
import Campus from '@/pages/Campus';
import Info from '@/pages/Info';
import Gifts from '@/pages/Gifts';
import Heart from '@/pages/Heart';
import Abilities from '@/pages/Abilities';
import Personality from '@/pages/Personality';
import Experience from '@/pages/Experience';
import Results from '@/pages/Results';

Vue.use(Router);

export default new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      name: 'Intro',
      component: Intro,
    },
    {
      path: '/campus',
      name: 'Campus',
      component: Campus,
    },
    {
      path: '/info',
      name: 'Info',
      component: Info,
    },
    {
      path: '/gifts',
      name: 'Gifts',
      component: Gifts,
    },
    {
      path: '/heart',
      name: 'Heart',
      component: Heart,
    },
    {
      path: '/abilities',
      name: 'Abilities',
      component: Abilities,
    },
    {
      path: '/personality',
      name: 'Personality',
      component: Personality,
    },
    {
      path: '/experience',
      name: 'Experience',
      component: Experience,
    },
    {
      path: '/results',
      name: 'Results',
      component: Results,
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js